module.exports = __webpack_public_path__ + "img/belt_center_pointer.008d75b8.gif";